import { type ClassValue, clsx } from "clsx";
import { format, parseISO } from "date-fns";
import { twMerge } from "tailwind-merge";

import { parseActivityDate } from "../utils/calendar/dateUtils.js";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(value?: string) {
  if (!value) {return "";}
  try {
    return format(parseISO(value), "MMM d, yyyy h:mm a");
  } catch {
    return value;
  }
}

export function formatCurrency(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) {return '$0.00';}
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

// Date-only values (a bare YYYY-MM-DD or a UTC-midnight timestamp) show their
// calendar day; parseISO would print the day before for UTC midnight in the US.
export function formatDate(date: string | null | undefined): string {
  if (!date) {return 'N/A';}
  try {
    return format(parseActivityDate(date), 'MMM d, yyyy');
  } catch {
    return 'N/A';
  }
}
